































import Vue from 'vue';
import store from '@/store';
import { Packet, BasePacket } from '@/models/packet';
import { OrgPeerGroup } from '@/models/orgStructure';
import { MemberRole, WebRequestStatus } from '@/models';
import * as Utils from '@/utils';

import CogsDefinition from '@/components/widgets/CogsDefinition.vue';
import PacketLibrary from '@/components/PacketLibrary.vue';

export default Vue.extend({
  components: {
    CogsDefinition,
    PacketLibrary
  },

  props: {
    peerGroupId: Number
  },

  computed: {
    organizationId(): number {
      return store.state.org.basic.organizationId;
    },

    peerGroup(): OrgPeerGroup {
      return store.getters.org.peerGroup(this.peerGroupId);
    },

    adminAccess(): boolean {
      return store.state.org.adminAccess;
    },

    canEdit(): boolean {
      if (this.adminAccess) {
        return true;
      }

      const userId = store.state.org.userInfo.userId;

      return this.peerGroup.members
        .filter(m => m.role === MemberRole.TEACHER)
        .some(m => m.userId === userId);
    },

    canEditPackets(): boolean {
      return this.canEdit && this.peerGroup.isActive;
    },

    connectedPacketIds(): number[] {
      return this.peerGroup.packets.map(p => p.packetId);
    },

    status(): WebRequestStatus {
      return store.state.org.activeRequests.group.getStatus(
        this.peerGroup.peerGroupId
      );
    },

    libraryPackets(): BasePacket[] {
      return store.state.org.org.packets
        .map(op => op.packet)
        .slice()
        .sort(Utils.sortNamed);
    }
  },

  methods: {
    connectPacket(selected: { packet: Packet; statusTrackerId: number }) {
      store.dispatch.org.addPeerGroupPacketConnection({
        tempAssociateId: selected.statusTrackerId,
        peerGroupId: this.peerGroup.peerGroupId,
        packetId: selected.packet.packetId
      });
    },

    disconnectPacket(removed: { packet: Packet; statusTrackerId: number }) {
      store.dispatch.org.removePacketPeerGroupConnection({
        tempAssociateId: removed.statusTrackerId,
        peerGroupId: this.peerGroup.peerGroupId,
        packetId: removed.packet.packetId
      });
    },

    exit() {
      store.dispatch.singlePoint.reset();
      store.dispatch.multiPoint.reset();

      this.$router.push({
        name: 'OrganizationPeerGroup',
        params: {
          organizationId: `${this.organizationId}`,
          peerGroupId: `${this.peerGroupId}`
        }
      });
    },

    createPacket() {
      this.$router.push({
        name: 'OrganizationPacketCreator',
        params: {
          organizationId: `${this.organizationId}`,
          peerGroupId: `${this.peerGroupId}`
        }
      });
    }
  }
});
